/**
 * 事業所区分のdisable制御を行う
 * その他のときはEnable、それ以外はDisable
 * @param officeDivisionValue 事業所区分番号
 */
const enableOfficeDivisionEtcIfOtherOfficeSelected = officeDivisionValue => {
  const $officeDivisionEtc = $('.js-office-division-etc');
  const [CORPORATE_OFFICE, PRIVATE_OFFICE, OTHER_OFFICE] = [1, 2 ,99];

  switch (officeDivisionValue) {
    case CORPORATE_OFFICE:
    case PRIVATE_OFFICE:
      // fall through
      $officeDivisionEtc.prop('disabled', true);
      $officeDivisionEtc.val('');
      break;
    case OTHER_OFFICE:
      $officeDivisionEtc.prop('disabled', false);
      break;
    default:
      console.error('Selected undefined radio button');
      break;
  }
};

/**
 * 画面表示時に呼び出す
 */
$(() => {
  const selectedOfficeDivisionValue = $('.js-office-division:checked').val();
  if (selectedOfficeDivisionValue != null) {
    enableOfficeDivisionEtcIfOtherOfficeSelected(parseInt(selectedOfficeDivisionValue));
  }
});

/**
 * 事業所区分が変更された際の処理
 */
$('.js-office-division').on('change', event => {
  enableOfficeDivisionEtcIfOtherOfficeSelected(parseInt(event.currentTarget.value));
});

/**
 * 住所が変更された際にdisplay_addressを更新する
 * displayAddress = prefecture + city + addressLines
 */
$(() => {
  const $prefecture = $('.js_input_prefecture');
  const $city = $('.js_input_city');
  const $addressLines = $('.js_input_address_lines');

  const updateDisplayAddressValue = value => {
    $('.js_input_display_address').val($prefecture.val() + $city.val() + $addressLines.val());
  };

  $city.on('input', event => {
    updateDisplayAddressValue();
  });

  $prefecture.on('input', event => {
    updateDisplayAddressValue();
  });

  $addressLines.on('input', event => {
    updateDisplayAddressValue();
  });
});
